import TransferDetail from '../features/transfers/layouts/detail';

// TSS vite/01 §"Pages are thin". Vista general de una sesión TE (post-T.E.):
// resumen + editar sesión + PDF + KPIs de la OPU.
export default function TransferDetailPage() {
    return <TransferDetail />;
}
